import React from 'react'

import { Field } from 'react-form'

import { FileUpload } from 'primereact/fileupload'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'


// this ia wrapper function for the prime react file upload so it can work with react-form's validation
// make sure it is used with Form tags
// this allows the validation to be triggered when the form is being submitted
// this is relying on a ref to be passed in to use to access the FileAPI
// if using the file upload with a url then this component shouldn't be used
// the key thing is the uploadRef property as this determines how to access the files uploaded
/*
  <Form>
  {formApi => {
    return (
      <div className=""p-grid">
        <div className="p-col-12">
          <FieldFileUpload field={"StatDec"} name="StatDec" accept=".pdf" uploadRef={statDecUpload} label="Upload Stat Dec" validationRules={validationRules} />
        </div>
      </div>
    )}
  }
  </Form>
*/
class FieldFileUpload extends React.Component {
  render() {
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
    }
    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form. It doesn't matter so much for file upload since we are using the ref
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
          const { onBlur, onChange, validate, field, validationRules, showAsTextOnly, uploadRef, ...rest } = this.props
          const { error, warning, success } = fieldApi

          let hasValidationRule = typeof validationRule !== "undefined"
          let isRequired = hasValidationRule && validationRule.IsRequired === true
          return (
            <React.Fragment>
              <div className="p-grid">
                <div className="p-col-12 field-label-container">
                  <label>
                    {this.props.label}
                    {isRequired === true && <span className="required-field-label"></span>}
                  </label>
                </div>
                <div className="p-col-12 field-element-container">
                  <FileUpload mode={'basic'} auto={false} chooseLabel={'Add File…'} {...rest} ref={uploadRef} />
                </div>
                {(error || warning || success) && <div className="p-col-12">
                  {error ? <FieldMessage color="#B30000" message={error} /> : null}
                  {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
                  {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
                </div>}
              </div>
            </React.Fragment>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, this.props.uploadRef, this.props.hasSavedFile)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }
}

export default FieldFileUpload;



// WEBPACK FOOTER //
// ./src/components/common/FieldFileUpload.js